// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IDocumentFileSchema {
  /**
   *
   *     Хэш файла.
   *     Хеши от файлов нужны для тех документов, целостность которых, нам важна.
   *     Например, если мы отправляем договор на подпись, то нам нужно будет сохранить этот хеш у себя,
   *     и перед отправкой проверить, что полученный файл не расходится с хешом.
   *
   */
  hash: string;
  /** Идентификатор документа **/
  id: number;
  /** Название документа **/
  name: string;
  /**
   *
   *     Подпись идентификатора документа.
   *     Нам нужно будет проверить подпись айдишников.
   *     Это нужно для того, чтобы один человек не мог подкинуть чужие айдишники и так подглядеть чужие файлы
   *
   */
  signature: string;
  /** Размер документа **/
  size: number;
  /** Тип файла (влияет на retention-policy) **/
  type: EType;
}

export enum EType {
  /** Временный файл **/
  'Temporary' = 'temporary',
}
